import { httpClient } from "./httpClient";
import { API_ROUTES } from "../constants/apiRoutes";

export const getPersonApi = async (params?: {
  id?: number;
  page?: number;
  limit?: number;
}) => {
  const url = params?.id
    ? `${API_ROUTES.PERSONS}?id=${params.id}`
    : `${API_ROUTES.PERSONS}?page=${params?.page ?? 1}&limit=${params?.limit ?? 12}`;

  return await httpClient(url, { method: "GET" });
};

export const getProjectsApi = async (params?: {
  id?: number;
  page?: number;
  limit?: number;
}) => {
  const url = params?.id
    ? `${API_ROUTES.PROJECTS}?id=${params.id}`
    : `${API_ROUTES.PROJECTS}?page=${params?.page ?? 1}&limit=${params?.limit ?? 12}`;

  return await httpClient(url, { method: "GET" });
};

export const getCategoriesApi = async (params?: {
  model?: string;
  category_id?: number;
}) => {
  const query = new URLSearchParams();

  if (params?.model) query.append("model", params.model);
  if (params?.category_id) query.append("category_id", String(params.category_id));

  const url = query.toString()
    ? `${API_ROUTES.CATEGORIES}?${query.toString()}`
    : API_ROUTES.CATEGORIES;

  return await httpClient(url, { method: "GET" });
};

export const searchApi = async (query: string) => {
  const encodedQuery = encodeURIComponent(query.trim());
  return await httpClient(`${API_ROUTES.SEARCH}?q=${encodedQuery}`, {
    method: "GET",
  });
};

export const getNewsApi = async (params?: {
  projects?: number;
  exclude_id?: number;
  search?: string;
  category?: number;
  is_featured?: 0 | 1;
  page?: number;
}) => {
  const query = new URLSearchParams();

  if (params?.projects) query.append("projects", String(params.projects));
  if (params?.exclude_id) query.append("exclude_id", String(params.exclude_id));
  if (params?.search) query.append("search", params.search);
  if (params?.category) query.append("category", String(params.category));
  if (params?.is_featured !== undefined)
    query.append("is_featured", String(params.is_featured));
  if (params?.page) query.append("page", String(params.page));

  const url = query.toString()
    ? `${API_ROUTES.NEWS}?${query.toString()}`
    : API_ROUTES.NEWS;

  return await httpClient(url, { method: "GET" });
};

export const getSingleNewsApi = async (id: number) => {
  const url = id ? `${API_ROUTES.NEWS}?id=${id}` : API_ROUTES.NEWS;
  return await httpClient(url, { method: "GET" });
};

export const toggleFollowUserApi = async (id: number) => {
  return await httpClient(`${API_ROUTES.FOLLOW_PERSON}?id=${id}`, {
    method: "POST",
  });
};

export const toggleFollowProjectApi = async (id: number) => {
  return await httpClient(`${API_ROUTES.FOLLOW_PROJECT}?id=${id}`, {
    method: "POST",
  });
};

export const checkFollowStatusApi = async (
  type: "persons" | "projects",
  id: number,
) => {
  return await httpClient(`${API_ROUTES.FOLLOW_CHECK}?type=${type}&id=${id}`, {
    method: "GET",
  });
};

export const getPodcastsApi = async (page?: number) => {
  const url = page ? `${API_ROUTES.PODCAST}?page=${page}` : API_ROUTES.PODCAST;
  return await httpClient(url, { method: "GET" });
};